import { Entity } from '@mainstage/catalog-model';

export const userCache = new Map<string, Entity>();
